import { GET_SUBSCRIPTION_PLANS, GET_FAQ, SUBSCRIPTION_PLANS_REQUESTED } from '../types/supabase.type'
const intialState = {
  subscriptionPlans: null,
  faq: [],
  subscriptionLoading: false,
}

const supabaseReducer = (state = intialState, action) => {
  switch (action.type) {
    case SUBSCRIPTION_PLANS_REQUESTED:
      return { ...state, subscriptionLoading: true }
    case GET_SUBSCRIPTION_PLANS:
    case GET_FAQ:
      return { ...state, ...action.payload, subscriptionLoading: false }
    default:
      return state
  }
}

export default supabaseReducer
